import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../../main-page/main-page.service';
import { PiperingBossesManagementComponent } from '../pipering-bosses-managment/pipering-bosses-managment.component';
import { PiperingBossModel } from '../../../../models/parts/pipering-boss.model';
declare var $: any;

@Component({
  selector: 'app-pipering-bosses-grid',
  template: `<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipering Boss?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePiperingBoss()">Delete</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isPiperingBossChoosen">
    <div class="input-effect">
        <input class="effect1" type="text" placeholder="">
        <label>Search</label>
        <span class="focus-border"></span>
    </div>
    <button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="createNewPiperingBoss()">Create</button>

    <table>
        <tr>
            <th *ngFor="let header of headers">{{header}}</th>
        </tr>
        <tr *ngFor="let piperingBoss of piperingBossesGridData, let row_no = index">
            <td>{{piperingBoss.name}}</td>
            <td>{{piperingBoss.claw}}</td>
            <td>{{piperingBoss.isDoubleConnected}}</td>
            <td class="columnWithIcons">
                <button type="button" class="btn editBtn" (click)="editPiperingBoss(piperingBoss)">
                    <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(piperingBoss)">
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PiperingBossesGridComponent implements OnInit {
  @Input() managmentComponent: PiperingBossesManagementComponent;
  isPiperingBossesHidden = true;
  piperingBossesGridData: PiperingBossModel[];
  selectedPiperingBoss: PiperingBossModel;
  isPiperingBossChoosen: boolean = false;
  elementIndex: number;
  headers: string[] = ['Name', 'Claw [mm]', 'Is double connected', ''];

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePiperingBossSubject.subscribe((value) => {
      this.piperingBossesGridData = this.piperingBossesGridData.filter(x => x._id !== value);
    });
    this.managmentComponent.stateSubject.subscribe((state) => {
      if (state !== null) {
        Object.assign(this.piperingBossesGridData[this.elementIndex], state);
      }
      this.isPiperingBossChoosen = false;
    })
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPiperingBosses().subscribe((response) => {
      this.piperingBossesGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPiperingBossesHidden = !this.isPiperingBossesHidden;
  }

  createNewPiperingBoss() {
    const piperingBoss = new PiperingBossModel();
    this.mainPageService.addNewPiperingBossIntoDb(JSON.stringify(piperingBoss)).subscribe((response) => {
      piperingBoss._id = response._id;
      piperingBoss.id = response.id;
      this.piperingBossesGridData.push(piperingBoss);
      this.elementIndex = this.piperingBossesGridData.indexOf(piperingBoss);
      this.managmentComponent.showManagmentPage(piperingBoss, true);
    });
    this.isPiperingBossChoosen = true;
  }

  setChoosenElement(element) {
    this.selectedPiperingBoss = {
      ...element,
    };
    this.elementIndex = this.piperingBossesGridData.indexOf(element);
  };

  editPiperingBoss(element) {
    this.selectedPiperingBoss = {
      ...element,
    };
    this.elementIndex = this.piperingBossesGridData.indexOf(element);
    this.managmentComponent.showManagmentPage(this.selectedPiperingBoss);
    this.isPiperingBossChoosen = true;
  }

  deletePiperingBoss() {
    this.mainPageService.removePiperingBoss(this.selectedPiperingBoss._id).subscribe(() => { }, () => { });
    this.mainPageService.deletePiperingBossSubject.next(this.selectedPiperingBoss._id);
  }
}
